import { render, staticRenderFns } from "./HtmlEditorTiptapToolbarUpload.vue?vue&type=template&id=5970a24e&"
import script from "./HtmlEditorTiptapToolbarUpload.vue?vue&type=script&lang=js&"
export * from "./HtmlEditorTiptapToolbarUpload.vue?vue&type=script&lang=js&"
import style0 from "./HtmlEditorTiptapToolbarUpload.vue?vue&type=style&index=0&id=5970a24e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports